import React from "react";
import PropTypes from "prop-types";
import ReadOnlyField from "./ReadOnlyField";

const PatternKeisokuView = ({
  documentCategoryText,
  documentTypeText,
  issueDate,
  categoryName,
  assignee,
  productName,
  productModel,
  originalDocNumber,
  purpose,
  customer,
  remarks,
}) => {
  const renderSelect = (label, text) => (
    <div className="form-row">
      <span className="form-label">{label}</span>
      <div className="form-value read-only-select">
        <select className="form-select" disabled>
          <option value="">{text || ""}</option>
        </select>
      </div>
    </div>
  );

  return (
    <div className="pattern-form">
      <div className="form-grid">
        {renderSelect("図面種類（計測）", documentCategoryText)}
        <ReadOnlyField label="日付" value={issueDate} />
        <ReadOnlyField label="図面名称" value={categoryName} />
        <ReadOnlyField label="担当者" value={assignee} />
        <ReadOnlyField label="製品名" value={productName} />
        {renderSelect("図面タイプ（計測）", documentTypeText)}
        <ReadOnlyField label="製品形式" value={productModel} />
        <ReadOnlyField label="元図番" value={originalDocNumber} />
        <ReadOnlyField label="用途" value={purpose} />
        <ReadOnlyField label="備考" value={remarks} />
        <ReadOnlyField label="得意先" value={customer} />
      </div>
    </div>
  );
};

PatternKeisokuView.propTypes = {
  documentCategoryText: PropTypes.string,
  documentTypeText: PropTypes.string,
  issueDate: PropTypes.string,
  categoryName: PropTypes.string,
  assignee: PropTypes.string,
  productName: PropTypes.string,
  productModel: PropTypes.string,
  originalDocNumber: PropTypes.string,
  purpose: PropTypes.string,
  customer: PropTypes.string,
  remarks: PropTypes.string,
};

PatternKeisokuView.defaultProps = {
  documentCategoryText: "",
  documentTypeText: "",
  issueDate: "",
  categoryName: "",
  assignee: "",
  productName: "",
  productModel: "",
  originalDocNumber: "",
  purpose: "",
  customer: "",
  remarks: "",
};

export default PatternKeisokuView;
